import React from 'react';

const About: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="inline-flex items-center gap-2 rounded-full border border-slate-700/70 bg-slate-900/60 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-300">
        About
        <span className="h-1 w-1 rounded-full bg-emerald-400" />
      </div>
      <div className="grid gap-10 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:items-start">
        <div className="space-y-4 text-sm leading-relaxed text-slate-200">
          <p>
            I&apos;m a full-stack engineer who architects, builds, and operates real-time data platforms that sit directly
            on the critical path of live sports and media. My work spans distributed .NET services, AWS infrastructure,
            and React/TypeScript frontends that teams trust when the broadcast light goes on.
          </p>
          <p>
            I&apos;ve led greenfield platform builds, guided engineering teams, and designed event-driven architectures
            that transform high-volume data into resilient, observable systems. I care about clear interfaces, predictable
            behavior, and creating leverage for other engineers through tooling, automation, and documentation.
          </p>
          <p>
            Before software, I competed as a Division I baseball player at the University of the Pacific. That background
            shows up in how I work: preparation, communication, and performing under real constraints—whether that&apos;s a
            live tournament broadcast, a hard integration deadline, or a production incident that needs to be resolved
            without downtime.
          </p>
        </div>
        <div className="space-y-4 rounded-2xl border border-slate-800/80 bg-slate-900/50 p-5 text-xs text-slate-200">
          <h3 className="text-sm font-semibold text-slate-50">At a glance</h3>
          <dl className="space-y-3">
            <div>
              <dt className="text-[11px] uppercase tracking-[0.18em] text-slate-500">Current role</dt>
              <dd className="mt-1 font-medium text-slate-100">
                Senior Software Developer, PGA TOUR — Broadcast &amp; data platforms
              </dd>
            </div>
            <div>
              <dt className="text-[11px] uppercase tracking-[0.18em] text-slate-500">Primary stack</dt>
              <dd className="mt-1 text-slate-200">
                .NET 8/10 (C#), AWS (ECS, Lambda, SQS, DynamoDB, AppSync), React, TypeScript, PostgreSQL, DynamoDB
              </dd>
            </div>
            <div>
              <dt className="text-[11px] uppercase tracking-[0.18em] text-slate-500">Domains</dt>
              <dd className="mt-1 text-slate-200">
                Live sports data, broadcast graphics, sports analytics, SaaS platforms, internal tools
              </dd>
            </div>
            <div>
              <dt className="text-[11px] uppercase tracking-[0.18em] text-slate-500">Education</dt>
              <dd className="mt-1 text-slate-200">
                M.S. Engineering Science – Computer Science
                <br />
                B.S. Computer Science – Application Development
                <br />
                University of the Pacific
              </dd>
            </div>
          </dl>
          <a
            href="/Nate Verlin CV.pdf"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center text-[11px] font-semibold uppercase tracking-[0.2em] text-emerald-300 hover:text-emerald-200"
          >
            View full resume
            <span className="ml-1 text-[13px]">↗</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;

